import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  const [showMore, setShowMore] = useState(false);

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Shraddha Patel </span>
            from <span className="purple"> Gandhinagr, Gujarat, India.</span>
          </p>
          <p style={{ textAlign: "justify" }}>I have completed <span className="purple"> 1.4 years </span>of professional training at <span className="purple">Tops Technology, Ahmedabad </span>, along with <span className="purple">1.8 years</span> of job experience in <span className="purple">front-end(React js) development.</span> I am currently working on React.js-based Admin Panel development where I handle dynamic data integration, reusable components, and responsive UI implementation.
          </p>

          {showMore && (
            <>
              <p style={{ textAlign: "justify" }}>My core expertise lies in <span className="purple">React.js and TypeScript</span>, and I am proficient in modern styling and state management tools like <span className="purple">Tailwind CSS, Next.js, Redux Toolkit, and React Query.</span> With a keen eye for performance optimization and clean code, I strive to create seamless user experiences that are both aesthetically pleasing and functionally robust.</p>
              <p style={{ textAlign: "justify" }}>I am constantly evolving my skills and am currently expanding my knowledge into back-end technologies,<span className="purple"> including Node.js, Express, and MongoDB</span>, to become a more versatile developer. I look forward to contributing to impactful projects while continuously pushing the boundaries of <span className="purple">front-end </span>innovation.</p>  </>
          )}
          <Button
            variant="primary"
            onClick={() => setShowMore(!showMore)}
            style={{ margin: "20px" }}
            className="px-4 py-3"
          >
            {showMore ? "Show Less" : "Show More"}
          </Button>
          <h2 className="purple" style={{ fontSize: "1.5em", paddingBottom: "20px" }}>Apart from coding, some other activities that I love to do!</h2>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Social Media Engagement (Following trends and influencers)
            </li>
            <li className="about-activity">
              <ImPointRight />  Adventure Activities
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Shraddha</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
